module.exports = __webpack_public_path__ + "img/address.c692fd41.svg";